import { TApplicationState } from '../../types/redux';

export function getPriceForMeterFromDeveloperDisplay(state: TApplicationState) {
  const {
    newbuilding: { priceForMeterFromDeveloperDisplay },
  } = state;

  return priceForMeterFromDeveloperDisplay;
}
